<div
    class="box-container"
    [class.drop-allowed]="dropAllowed"
    cdkDropList
    (cdkDropListDropped)="onListDrop($event)"
    (cdkDropListEntered)="onDropListEntered($event)"
    (cdkDropListExited)="onDropListExited($event)">
    <mat-checkbox ngDefaultControl class="primary-button" [checked]="datasource.selected" (change)="onChanged($event)" labelPosition="after">
        <span class="label" [title]="datasource.name">{{ datasource.name }}</span>
        @if (datasource.count !== 0) {
            <span class="counter">{{ datasource.count | avmFileCounter }}</span>
        }
    </mat-checkbox>
</div>
